import type { HomepageContent } from '../../cms/homepage'
import HomepageSectionHeader from './HomepageSectionHeader'

type WhyPitSectionProps = {
  content: HomepageContent['whyDifferent']
}

export default function WhyPitSection({ content }: WhyPitSectionProps) {
  return (
    <section className="home-section">
      <HomepageSectionHeader title={content.title} intro={content.intro} />
      <div className="home-value-grid">
        {content.pillars.map((pillar, index) => (
          <article key={pillar.title} className={`home-value-card home-value-card-${index + 1}`}>
            <h3>{pillar.title}</h3>
            <p>{pillar.body}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
